import { Avatar, Stack } from '@mui/material';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useModal } from '@ebay/nice-modal-react';

import { Button, Typography, SizingMultiplier, Paper } from '@ocx/ui';
import { ModalDrawer, CompleteDecoration } from '@ocx/ui-modals';
import { buttonTextMessages } from '@ocx-app/modules/localization/button-text.messages';
import { useAsset, useConfiguration } from '@ocx/data-configuration';
import { useGetNavigationActions } from '@ocx-app/hooks/useGetNavigationActions';

import { messages } from './edit-profile.messages';

type EIAVPromotionSectionProps = {
  onClick(): void;
};

const EIAVPromotionSection = (props: EIAVPromotionSectionProps) => {
  const { onClick } = props;

  const ageRestrictedSrc = useAsset('AgeRestricted');

  return (
    <Stack component={Paper} outlined spacing={SizingMultiplier.md}>
      <Stack direction="row" alignItems="center" spacing={SizingMultiplier.md}>
        <Avatar src={ageRestrictedSrc} />
        <Typography variant="subtitle1">
          <FormattedMessage {...messages['profile-completed-action-sheet:eaiv-promotion-message']} />
        </Typography>
      </Stack>
      <Button onClick={onClick} fullWidth>
        <FormattedMessage {...messages['profile-completed-action-sheet:eaiv-promotion-button-text']} />
      </Button>
    </Stack>
  );
};

export const ProfileCompletedActionSheetController = () => {
  const { visible, hide, remove } = useModal();
  const { isEAIVPromotionOnProfileCompletedEnabled } = useConfiguration('productInterests');
  const { pushToProductInterests } = useGetNavigationActions();

  const handleNavigateToProductInterests = useCallback(() => {
    pushToProductInterests();
    hide();
  }, [hide, pushToProductInterests]);

  return (
    <ModalDrawer open={visible} onClose={hide} onExited={remove}>
      <CompleteDecoration />
      {/* Decorator offset */}
      <div style={{ height: 65 }} />

      <Stack p={SizingMultiplier.lg} pt={SizingMultiplier.xl} spacing={SizingMultiplier.md}>
        <Typography textAlign="center" variant="h5">
          <FormattedMessage {...messages['profile-completed-action-sheet:complete-title']} />
        </Typography>
        {isEAIVPromotionOnProfileCompletedEnabled && (
          <EIAVPromotionSection onClick={handleNavigateToProductInterests} />
        )}
        <Button variant="text" onClick={hide} fullWidth>
          <FormattedMessage {...buttonTextMessages['button-text:close']} />
        </Button>
      </Stack>
    </ModalDrawer>
  );
};
